/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWatch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M13.318 1.748L13 1.75H9.792A1.25 1.25 0 008.55 2.887l-.203 2.282a7.87 7.87 0 017.237-.037l-.188-2.247a1.25 1.25 0 00-.32-.727c-.189-.206-.434-.317-.784-.37-.3-.046-.607-.043-.973-.04zm3.863 4.488l-.292-3.479v-.004a2.75 2.75 0 00-.706-1.605c-.492-.54-1.101-.757-1.665-.843-.433-.066-.897-.061-1.275-.057L13 .25H9.792a2.752 2.752 0 00-2.737 2.503L6.738 6.31C5.101 7.828 4.288 9.92 4.288 12c0 2.097.826 4.207 2.492 5.728l.313 3.518a2.752 2.752 0 002.736 2.504h3.209c.075 0 .157 0 .243.002.378.004.842.01 1.275-.057.564-.086 1.173-.303 1.665-.843a2.75 2.75 0 00.706-1.605l.295-3.52c1.664-1.521 2.49-3.63 2.49-5.727 0-2.114-.84-4.24-2.531-5.764zm-1.323.847a.754.754 0 00.276.23c1.381 1.22 2.078 2.947 2.078 4.687 0 1.788-.736 3.563-2.195 4.788-2.29 1.924-5.745 1.924-8.035 0-1.458-1.225-2.194-3-2.194-4.788 0-1.788.736-3.563 2.194-4.788 2.238-1.88 5.588-1.923 7.876-.13zm-.235 11.764a7.87 7.87 0 01-7.237.005l.2 2.26a1.251 1.251 0 001.245 1.138h3.207l.317.002c.367.003.674.006.974-.04.35-.053.595-.164.783-.37.183-.2.296-.456.32-.727l.001-.002.19-2.266zM12 8.25a.75.75 0 01.75.75v2.69l1.28 1.28a.75.75 0 11-1.06 1.06l-1.5-1.5a.75.75 0 01-.22-.53V9a.75.75 0 01.75-.75z'
      />
    </svg>
  );
}

export default SvgWatch;
